import BettingSimulator from './components/BettingSimulator';

function App() {
  return (
    <div className="App">
      <BettingSimulator />
    </div>
  );
}

export default App;
